export enum LanguageCode {
  EN = 'en',
  ES = 'es',
  CA = 'ca',
  PT = 'pt',
  NO = 'no',
  DE = 'de',
  IT = 'it',
}
